<template>
  <!-- MYAC-1269 — the two halves of a conversation list, one tap apart: the
       person's own, and what others shared (« Partagées avec vous » was easy to
       miss at the bottom of a long list). A dot on « Partagées » says something
       waits there. The choice lives in the store, so the drawer and the sidebar
       agree and a route change keeps it. -->
  <SelectButton :model-value="tab" :options="options" option-label="label" option-value="value"
    :allow-empty="false" size="small" :aria-label="t('conversations.tabs.label')"
    data-testid="conversation-list-tabs" @update:model-value="(v: ConversationListTab) => v && conversations.setListTab(v)">
    <template #option="{ option }">
      <span class="tab" :data-testid="`conversation-tab-${option.value}`">
        {{ option.label }}<span class="count">{{ option.count }}</span>
        <i v-if="option.value === 'shared' && conversations.sharedHasNews" class="dot"
          :title="t('conversations.tabs.shared_news')" data-testid="conversation-tab-shared-dot" />
      </span>
    </template>
  </SelectButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SelectButton from 'primevue/selectbutton'
import { useConversationsStore, type ConversationListTab } from '@/stores/conversations'

const { t } = useI18n()
const conversations = useConversationsStore()
const tab = computed(() => conversations.listTab)
const options = computed(() => [
  { value: 'mine' as ConversationListTab, label: t('conversations.tabs.mine'), count: conversations.recent.length },
  { value: 'shared' as ConversationListTab, label: t('conversations.tabs.shared'), count: conversations.shared.length },
])
</script>

<style scoped>
/* The list column can be narrow: each half takes an equal share and its label
   never wraps under its count. */
.p-selectbutton { display: flex; width: 100%; }
:deep(.p-togglebutton) { flex: 1 1 0; min-width: 0; padding-inline: 8px; }
.tab { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }
.count { font-size: 11px; opacity: 0.75; font-variant-numeric: tabular-nums; }
.dot { width: 7px; height: 7px; border-radius: 50%; background: var(--p-primary-color); }
</style>
